import React from 'react';
import { Globe, Code, Smartphone, Palette, Wrench, Layers } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const Services = () => {
  const services = [
    {
      icon: <Globe className="w-8 h-8" />,
      title: 'Website Development',
      description: 'Custom websites built with modern technologies, optimized for performance and user experience.',
      color: 'from-blue-500 to-cyan-500'
    },
    {
      icon: <Code className="w-8 h-8" />,
      title: 'Angular Applications',
      description: 'Enterprise-grade Angular applications with robust architecture and scalable solutions.',
      color: 'from-red-500 to-pink-500'
    },
    {
      icon: <Layers className="w-8 h-8" />,
      title: 'React Applications',
      description: 'Modern React applications with interactive UIs and seamless user experiences.',
      color: 'from-cyan-500 to-blue-500'
    },
    {
      icon: <Smartphone className="w-8 h-8" />,
      title: 'Python Backend',
      description: 'Powerful backend systems using Python frameworks for reliable and efficient performance.',
      color: 'from-yellow-500 to-orange-500'
    },
    {
      icon: <Palette className="w-8 h-8" />,
      title: 'UI/UX Design',
      description: 'Beautiful, intuitive interfaces that engage users and drive conversions.',
      color: 'from-violet-500 to-fuchsia-500'
    },
    {
      icon: <Wrench className="w-8 h-8" />,
      title: 'Website Maintenance',
      description: 'Ongoing support, updates, and maintenance to keep your website running smoothly.',
      color: 'from-green-500 to-emerald-500'
    }
  ];

  return (
    <section id="services" className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
            Our <span className="text-blue-600">Services</span>
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Comprehensive web development solutions tailored to your business needs
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <Card
              key={index}
              className="group hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-0 bg-white overflow-hidden"
            >
              <CardContent className="p-8">
                <div className={`w-16 h-16 bg-gradient-to-br ${service.color} rounded-2xl flex items-center justify-center mb-6 text-white group-hover:scale-110 transition-transform duration-300`}>
                  {service.icon}
                </div>
                <h3 className="text-2xl font-semibold text-slate-900 mb-3">{service.title}</h3>
                <p className="text-slate-600 leading-relaxed">{service.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;